import type { Category } from '@/5_entities/Category'

export interface Pagination {
  totalCount: number
  pageSize: number
  pageIndex: number
  currentPage: number
  pagesCount: number
  offset: number
}

export class EmptyPagination implements Pagination {
  public totalCount = 0
  public pageSize = 0
  public pageIndex = 0
  public currentPage = 0
  public pagesCount = 0
  public offset = 0
}

export interface SearchResultItem<T, R> {
  type: T
  object: R
}

export interface SearchResult<ObjectType, ObjectModel> {
  pagination: Pagination
  items: SearchResultItem<ObjectType, ObjectModel>[]
}

export enum SearchSorting {
  nearest = 'nearestFirst',
  cheapest = 'cheapestFirst',
  expensive = 'expensiveFirst'
}

export type SearchSortingTitle = 'ближайшие' | 'дешевле' | 'дороже' | 'популярные'
export const SearchSortingMap: Record<SearchSorting, SearchSortingTitle> = {
  nearestFirst: 'ближайшие',
  cheapestFirst: 'дешевле',
  expensiveFirst: 'дороже'
}

export interface BaseSearchFilters {
  pagination: Pick<Pagination, 'pageSize' | 'currentPage'>
  filter: {
    fromDateTime?: string
    tillDateTime?: string
    textQuery?: string
    fromPrice?: number
    tillPrice?: number
    categoryIds?: Category['id'][]
  }
  sorting?: SearchSorting
}

export type TimetableFilterMode = 'date' | 'venue'

export enum EntityStatus {
  disabled,
  enabled
}
